import { useQuery } from "@apollo/client";
import { GET_ACTION_CARDS } from "./queries";

export const useGetActions = () => {
  const { data, error, loading } = useQuery(GET_ACTION_CARDS);

  return {
    loading: loading,
    data: data?.getCurrentActions,
    error: error
  };
};
